<td class="text-center padding-left-0" [hidden]="!showCheckIcon" style="width:20%"><i class="fas fa-check color-green f-20"></i></td>
